//Expanded from https://stackoverflow.com/questions/20618355/the-simplest-possible-javascript-countdown-timer

var timerTemplate = require('./countdowntimer-template.handlebars');

function CountDownTimer(containerId, duration, granularity) {
    this.containerId = `#${containerId}`;
    this.duration = duration;
    this.granularity = granularity || 1000; //Default to one second
    this.onTickCallbacks = [];
    this.onExpiredCallbacks = [];
    this.isRunning = false;
    this.secondsRemaining = duration;
    this.large = true;
    this.small = false;
}

CountDownTimer.prototype.start = function () {
    if (this.isRunning) return;
    this.isRunning = true;

    let requestedSize = $(this.containerId).data('size');
    if (requestedSize == "large") {
        this.large = true;
        this.small = false;
    } else if (requestedSize == "small") {
        this.large = false;
        this.small = true;
    }

    var start = Date.now(),
        _this = this,
        $container = $(_this.containerId),
        secondsRemaining,
        parsedTimerParts;

    (function timer() {
        secondsRemaining = _this.duration - (((Date.now() - start) / 1000) | 0);
        parsedTimerParts = CountDownTimer.parse(secondsRemaining);

        if (secondsRemaining > 0) {
            _this.secondsRemaining = secondsRemaining;

            _this.onTickCallbacks.forEach(function (fn) {
                fn.call(this, parsedTimerParts, secondsRemaining);
            }, _this);

            setTimeout(timer, _this.granularity);
        } else {
            secondsRemaining = 0;
            _this.isRunning = false;
            _this.secondsRemaining = secondsRemaining;

            _this.onExpiredCallbacks.forEach(function (fn) {
                fn.call(this, parsedTimerParts, secondsRemaining);
            }, _this);
        }

        var html = timerTemplate({ timerdata: parsedTimerParts, large: _this.large, small: _this.small });
        $container.html(html);
    }());
};

CountDownTimer.prototype.onTick = function (fn) {
    if (typeof fn === 'function') {
        this.onTickCallbacks.push(fn);
    }
    return this;
};

CountDownTimer.prototype.onExpire = function (fn) {
    if (typeof fn === 'function') {
        this.onExpiredCallbacks.push(fn);
    }
    return this;
};

// CountDownTimer.prototype.isExpired = function () {
//     return !this.isRunning;
// };

CountDownTimer.parse = function (remainingSeconds) {

    //set days, subtract from seconds
    var days = Math.floor(remainingSeconds / 86400);
    remainingSeconds -= days * 86400;

    //set hours, subtract from seconds
    var hours = Math.floor(remainingSeconds / 3600);
    remainingSeconds -= hours * 3600;

    //set minutes, subtract from seconds
    var minutes = Math.floor(remainingSeconds / 60);
    remainingSeconds -= minutes * 60;

    var seconds = (remainingSeconds % 60);

    return {
        'days': days < 10 ? `0${days}` : `${days}`,
        'hours': hours < 10 ? `0${hours}` : `${hours}`,
        'minutes': minutes < 10 ? `0${minutes}` : `${minutes}`,
        'seconds': seconds < 10 ? `0${seconds}` : `${seconds}`
    };
};

module.exports = CountDownTimer;


// WEBPACK FOOTER //
// ./shared/components/countdowntimer/countdowntimer.js